import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { messages, languagesCodes } from './translations';

Vue.use(VueI18n);

let defaultLang = 'it';

if (Object.keys(languagesCodes).includes(navigator.language.substr(0, 2))) {
  defaultLang = navigator.language.substr(0, 2);
}

export const i18n = new VueI18n({
  locale: localStorage.getItem('lang-code') || defaultLang,
  fallbackLocale: 'it',
  silentFallbackWarn: true,
  formatFallbackMessages: true,
  messages,
});
